import { studentPaymentState } from "./atom";
import { studentPaymentSelector } from "./selector";

export default {
  studentPaymentState,
  studentPaymentSelector,
};
